const CARDS = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20manga%20illustration%20style%20scene%20with%20soft%20warm%20lighting%2C%20two%20characters%20in%20emotional%20moment%2C%20cherry%20blossom%20petals%2C%20clean%20modern%20Korean%20webtoon%20art%20style%2C%20warm%20coral%20and%20cream%20tones%2C%20soft%20gradient%20background&width=600&height=400&seq=cards-img-01&orientation=landscape',
    tag: '韩漫精选',
    title: '纯爱天堂：最甜韩漫分类推荐',
    desc: '精选纯爱分类中口碑最高的 20 部韩漫，从校园恋到都市情，每一部都让人心动不已。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20style%20illustration%20with%20sword%20fighting%20scene%2C%20dramatic%20composition%2C%20Japanese%20shonen%20manga%20art%20style%2C%20speed%20lines%2C%20warm%20orange%20and%20dark%20accents%2C%20epic%20battle%20atmosphere%2C%20stylized%20rendering&width=600&height=400&seq=cards-img-02&orientation=landscape',
    tag: '日漫推荐',
    title: '热血不止：日漫必看动作榜单',
    desc: '从经典到新番，热血分类下最不容错过的日漫作品，战斗场面炸裂，情感线也毫不逊色。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20ancient%20style%20manga%20illustration%20with%20flowing%20robes%2C%20traditional%20architecture%2C%20ink%20wash%20painting%20influence%2C%20fantasy%20elements%2C%20warm%20golden%20and%20jade%20tones%2C%20elegant%20composition%2C%20ethereal%20atmosphere&width=600&height=400&seq=cards-img-03&orientation=landscape',
    tag: '国漫风采',
    title: '东方美学：国漫古风精品合集',
    desc: '国漫古风分类精选，画风承载千年文化底蕴，剧情融汇东方奇幻想象。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20suspense%20thriller%20manga%20style%20illustration%20with%20detective%20theme%2C%20dark%20rainy%20alley%2C%20silhouette%20figures%2C%20warm%20lamp%20light%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20stylized%20comic%20panel%20composition&width=600&height=400&seq=cards-img-04&orientation=landscape',
    tag: '悬疑推理',
    title: '烧脑之旅：悬疑分类高分推荐',
    desc: '悬疑迷的宝藏清单，从推理到惊悚层层递进，每一部都让你猜到最后一页。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Lighthearted%20comedy%20manga%20style%20illustration%20with%20funny%20character%20expressions%2C%20school%20setting%2C%20bright%20warm%20colors%2C%20playful%20atmosphere%2C%20chibi%20style%20elements%2C%20speech%20bubbles%2C%20cheerful%20vibe&width=600&height=400&seq=cards-img-05&orientation=landscape',
    tag: '搞笑日常',
    title: '每日一笑：搞笑分类人气作品',
    desc: '搞笑分类中播放量最高的作品，无论是午休还是睡前，一话就能让你忘掉烦恼。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          分类推荐
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          各类型精选作品，帮你快速找到下一部心头好
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CARDS.map((card) => (
            <div key={card.title} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <div className="h-[200px] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-primary-100 text-primary-600 text-[11px] font-bold mb-2">
                  {card.tag}
                </span>
                <h3 className="text-[15px] font-bold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-[13px] leading-relaxed text-foreground-500">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}